export default {"src":"/_next/static/media/valentines-day---banner.1e19b46d.svg","height":188,"width":668,"blurWidth":0,"blurHeight":0};